export const SITE = {
  name: "APSARA Kollektion",
  claim: "Punjabi Schmuck & Suits",
  // Echte Nummer (vom Nutzer im Chat angegeben)
  whatsappNumber: "491776702169",
  phoneDisplay: "+49 177 6702169",
  phoneHref: "tel:+491776702169",
  whatsappText:
    "Sat Sri Akal! Ich habe eure Seite gesehen und interessiere mich für Schmuck bzw. Punjabi Suits.",
};

export const waLink = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
  SITE.whatsappText
)}`;

// Rechtliche Angaben — Platzhalter in [Klammern] bitte nachtragen
export const IMPRESSUM = {
  name: "Kiranjit Kaur",
  email: "Kiranjit0303@gmail.com",
};
